//# sourceMappingURL=output.mjs.map
/// <reference types="./output.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $uuid from "../../../tiamat/crypto/uuid.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class OutlineItem extends $CustomType {
  constructor(id, title, objective, queries, writing_instructions, sources, parent_id) {
    super();
    this.id = id;
    this.title = title;
    this.objective = objective;
    this.queries = queries;
    this.writing_instructions = writing_instructions;
    this.sources = sources;
    this.parent_id = parent_id;
  }
}
export const OutlineItem$OutlineItem = (id, title, objective, queries, writing_instructions, sources, parent_id) =>
  new OutlineItem(id,
  title,
  objective,
  queries,
  writing_instructions,
  sources,
  parent_id);
export const OutlineItem$isOutlineItem = (value) =>
  value instanceof OutlineItem;
export const OutlineItem$OutlineItem$id = (value) => value.id;
export const OutlineItem$OutlineItem$0 = (value) => value.id;
export const OutlineItem$OutlineItem$title = (value) => value.title;
export const OutlineItem$OutlineItem$1 = (value) => value.title;
export const OutlineItem$OutlineItem$objective = (value) => value.objective;
export const OutlineItem$OutlineItem$2 = (value) => value.objective;
export const OutlineItem$OutlineItem$queries = (value) => value.queries;
export const OutlineItem$OutlineItem$3 = (value) => value.queries;
export const OutlineItem$OutlineItem$writing_instructions = (value) =>
  value.writing_instructions;
export const OutlineItem$OutlineItem$4 = (value) => value.writing_instructions;
export const OutlineItem$OutlineItem$sources = (value) => value.sources;
export const OutlineItem$OutlineItem$5 = (value) => value.sources;
export const OutlineItem$OutlineItem$parent_id = (value) => value.parent_id;
export const OutlineItem$OutlineItem$6 = (value) => value.parent_id;

export class Explicit extends $CustomType {}
export const OutlineType$Explicit = () => new Explicit();
export const OutlineType$isExplicit = (value) => value instanceof Explicit;

export class Implicit extends $CustomType {}
export const OutlineType$Implicit = () => new Implicit();
export const OutlineType$isImplicit = (value) => value instanceof Implicit;

export class NonExistent extends $CustomType {}
export const OutlineType$NonExistent = () => new NonExistent();
export const OutlineType$isNonExistent = (value) =>
  value instanceof NonExistent;

export class Metadata extends $CustomType {
  constructor(explanation, outline_type) {
    super();
    this.explanation = explanation;
    this.outline_type = outline_type;
  }
}
export const Metadata$Metadata = (explanation, outline_type) =>
  new Metadata(explanation, outline_type);
export const Metadata$isMetadata = (value) => value instanceof Metadata;
export const Metadata$Metadata$explanation = (value) => value.explanation;
export const Metadata$Metadata$0 = (value) => value.explanation;
export const Metadata$Metadata$outline_type = (value) => value.outline_type;
export const Metadata$Metadata$1 = (value) => value.outline_type;

export class Outline extends $CustomType {
  constructor(title, items, metadata) {
    super();
    this.title = title;
    this.items = items;
    this.metadata = metadata;
  }
}
export const Outline$Outline = (title, items, metadata) =>
  new Outline(title, items, metadata);
export const Outline$isOutline = (value) => value instanceof Outline;
export const Outline$Outline$title = (value) => value.title;
export const Outline$Outline$0 = (value) => value.title;
export const Outline$Outline$items = (value) => value.items;
export const Outline$Outline$1 = (value) => value.items;
export const Outline$Outline$metadata = (value) => value.metadata;
export const Outline$Outline$2 = (value) => value.metadata;

export class OutlineOutput extends $CustomType {
  constructor(org_id, outline, session_id, user_id) {
    super();
    this.org_id = org_id;
    this.outline = outline;
    this.session_id = session_id;
    this.user_id = user_id;
  }
}
export const OutlineOutput$OutlineOutput = (org_id, outline, session_id, user_id) =>
  new OutlineOutput(org_id, outline, session_id, user_id);
export const OutlineOutput$isOutlineOutput = (value) =>
  value instanceof OutlineOutput;
export const OutlineOutput$OutlineOutput$org_id = (value) => value.org_id;
export const OutlineOutput$OutlineOutput$0 = (value) => value.org_id;
export const OutlineOutput$OutlineOutput$outline = (value) => value.outline;
export const OutlineOutput$OutlineOutput$1 = (value) => value.outline;
export const OutlineOutput$OutlineOutput$session_id = (value) =>
  value.session_id;
export const OutlineOutput$OutlineOutput$2 = (value) => value.session_id;
export const OutlineOutput$OutlineOutput$user_id = (value) => value.user_id;
export const OutlineOutput$OutlineOutput$3 = (value) => value.user_id;

function decode_outline_type() {
  return $decode.then$(
    $decode.string,
    (str) => {
      if (str === "explicit") {
        return $decode.success(new Explicit());
      } else if (str === "implicit") {
        return $decode.success(new Implicit());
      } else if (str === "non_existent") {
        return $decode.success(new NonExistent());
      } else {
        return $decode.failure(new NonExistent(), "OutlineType");
      }
    },
  );
}

export function outline_type_to_display(outline_type) {
  if (outline_type instanceof Explicit) {
    return "An explicit outline structure was mentioned in the RFP requirements.";
  } else if (outline_type instanceof Implicit) {
    return "An implicit outline structure was extracted from the RFP requirements.";
  } else {
    return "No outline instructions in the document, suggesting a generic template.";
  }
}

function outline_metadata_decoder() {
  return $decode.field(
    "outline_type",
    decode_outline_type(),
    (outline_type) => {
      return $decode.field(
        "explanation",
        $decode.string,
        (explanation) => {
          return $decode.success(new Metadata(explanation, outline_type));
        },
      );
    },
  );
}

/**
 * to replace with decrypt
 * 
 * @ignore
 */
function optional_field(field, decoder, next) {
  let decoder$1 = $decode.optional(decoder);
  return $decode.optional_field(field, new None(), decoder$1, next);
}

export function outline_item_decoder() {
  return $decode.field(
    "title",
    $decode.string,
    (title) => {
      return $decode.optional_field(
        "id",
        $uuid.new$(),
        $decode.string,
        (id) => {
          return optional_field(
            "parent_id",
            $decode.string,
            (parent_id) => {
              return $decode.field(
                "objective",
                $decode.string,
                (objective) => {
                  return $decode.field(
                    "queries",
                    $decode.list($decode.string),
                    (queries) => {
                      return $decode.field(
                        "writing_instructions",
                        $decode.optional($decode.string),
                        (writing_instructions) => {
                          return $decode.success(
                            new OutlineItem(
                              id,
                              title,
                              objective,
                              queries,
                              writing_instructions,
                              toList([]),
                              parent_id,
                            ),
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function outline_decoder() {
  return $decode.field(
    "title",
    $decode.string,
    (title) => {
      return $decode.field(
        "items",
        $decode.list(outline_item_decoder()),
        (items) => {
          return $decode.field(
            "metadata",
            outline_metadata_decoder(),
            (metadata) => {
              return $decode.success(new Outline(title, items, metadata));
            },
          );
        },
      );
    },
  );
}

export function outline_output_decoder() {
  return $decode.field(
    "org_id",
    $decode.string,
    (org_id) => {
      return $decode.field(
        "outline",
        outline_decoder(),
        (outline) => {
          return $decode.field(
            "session_id",
            $decode.string,
            (session_id) => {
              return $decode.field(
                "user_id",
                $decode.string,
                (user_id) => {
                  return $decode.success(
                    new OutlineOutput(org_id, outline, session_id, user_id),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function outline_type_to_json(outline_type) {
  if (outline_type instanceof Explicit) {
    return $json.string("explicit");
  } else if (outline_type instanceof Implicit) {
    return $json.string("implicit");
  } else {
    return $json.string("non_existent");
  }
}

function metadata_to_json(metadata) {
  return $json.object(
    toList([
      ["explanation", $json.string(metadata.explanation)],
      ["outline_type", outline_type_to_json(metadata.outline_type)],
    ]),
  );
}

export function outline_item_to_json(outline_item) {
  return $json.object(
    toList([
      ["title", $json.string(outline_item.title)],
      ["id", $json.string(outline_item.id)],
      ["objective", $json.string(outline_item.objective)],
      ["queries", $json.array(outline_item.queries, $json.string)],
      [
        "writing_instructions",
        $json.nullable(outline_item.writing_instructions, $json.string),
      ],
      ["parent_id", $json.nullable(outline_item.parent_id, $json.string)],
      ["sources", $json.array(outline_item.sources, $json.string)],
    ]),
  );
}

export function outline_to_json(outline) {
  return $json.object(
    toList([
      ["title", $json.string(outline.title)],
      ["items", $json.array(outline.items, outline_item_to_json)],
      ["metadata", metadata_to_json(outline.metadata)],
    ]),
  );
}

export function outline_output_to_json(data) {
  return $json.object(
    toList([
      ["org_id", $json.string(data.org_id)],
      ["outline", outline_to_json(data.outline)],
      ["session_id", $json.string(data.session_id)],
      ["user_id", $json.string(data.user_id)],
    ]),
  );
}

export function empty_item() {
  return new OutlineItem(
    $uuid.new$(),
    "New Section",
    "",
    toList([""]),
    new None(),
    toList([]),
    new None(),
  );
}
